module.exports = __webpack_public_path__ + "static/media/Order_processing_video.af0d5bdb.mp4";